import React, { PureComponent } from "react";
import { I18n } from "@lingui/react";
import {
  DataGridHeader,
  DataGridHeading,
  Main,
  Checkbox,
  Badge,
} from "@conserveit/blocks";
import { equipColumns } from "../../../utils/columns";
import SortArrow from "../../SortArrow";
import { getUniqIssues } from "../../../redux/modules/insights/utils";

class EquipHeader extends PureComponent {
  render() {
    const {
      isAllSelected,
      onSelectAll,
      hits,
      activeSort,
      sortDirection,
      onSort,
      isAllSelectedDisabled,
      children,
      hideEdits,
    } = this.props;

    return (
      <I18n>
        {({ i18n }) => (
          <DataGridHeader cursor="pointer">
            <DataGridHeading>
              <div hidden={hideEdits}>
                <Checkbox 
                  disabled={isAllSelectedDisabled}
                  checked={isAllSelected}
                  onChange={onSelectAll}
                  data-cy="selectAllHits"
                  small
                />
              </div>
            </DataGridHeading>
            <DataGridHeading
              minWidth={equipColumns.LATEST.width}
              onClick={onSort(
                equipColumns.LATEST.key,
                equipColumns.LATEST.sortDirection
              )}
            >
              <Main>
                {equipColumns.LATEST.label(i18n)}
                {activeSort === equipColumns.LATEST.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading
              minWidth={equipColumns.EQUIP_NAME.width}
              maxWidth="200px"
              onClick={onSort(
                equipColumns.EQUIP_NAME.key,
                equipColumns.EQUIP_NAME.sortDirection
              )}
            >
              <Main>
                {equipColumns.EQUIP_NAME.label(i18n)}
                {activeSort === equipColumns.EQUIP_NAME.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading
              minWidth={equipColumns.TRIGGERED_RULES.width}
              onClick={onSort(
                equipColumns.TRIGGERED_RULES.key,
                equipColumns.TRIGGERED_RULES.sortDirection
              )}
            >
              <Main>
                {equipColumns.TRIGGERED_RULES.label(i18n)}
                {activeSort === equipColumns.TRIGGERED_RULES.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading
              minWidth={equipColumns.EQUIP_DETAILS.width}
              onClick={onSort(
                equipColumns.EQUIP_DETAILS.key,
                equipColumns.EQUIP_DETAILS.sortDirection
              )}
            >
              <Main>
                {equipColumns.EQUIP_DETAILS.label(i18n)}
                {activeSort === equipColumns.EQUIP_DETAILS.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading
              minWidth={equipColumns.RULE_TYPE.width}
              onClick={onSort(
                equipColumns.RULE_TYPE.key,
                equipColumns.RULE_TYPE.sortDirection
              )}
            >
              <Main>
                {equipColumns.RULE_TYPE.label(i18n)}
                {activeSort === equipColumns.RULE_TYPE.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading
              minWidth="120px"
              onClick={onSort(
                equipColumns.ACTIONS_COUNT.key,
                equipColumns.ACTIONS_COUNT.sortDirection
              )}
            >
              <Main>
                {equipColumns.ACTIONS_COUNT.label(i18n)}{" "}
                <Badge>{getUniqIssues(hits).length}</Badge>
                {activeSort === equipColumns.ACTIONS_COUNT.key && (
                  <SortArrow direction={sortDirection} />
                )}
              </Main>
            </DataGridHeading>
            <DataGridHeading minWidth="132px" />
            {children}
          </DataGridHeader>
        )}
      </I18n>
    );
  }
}

export default EquipHeader;
